
<template>
  <dropdown
    v-model="localValue"
    :name="name"
    :options="dropdownOptions"
    :default-option="null"
    required
  />
</template>

<script>
const numberText = [ '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th' ];

export default {
  name: 'CommonAreaDropdown',
  components: {
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    roomNumber: {
      type: Number,
      required: true,
    },
    propertyType: {
      type: String,
      required: true,
      // validator: (prop) => {
      //   if ([ 'Residential', 'Daycare' ].indexOf(prop) === -1) {
      //     throw new Error("propertyType accepts only ['Residential', 'Daycare']");
      //   }
      //   return true;
      // },
    },
    // Type is the v-model!
    value: {
      type: String,
      default: 'window',
      // validator: (prop) => {
      //   if ([ 'window', 'no-window' ].indexOf(prop) === -1) {
      //     throw new Error("type (v-model) accepts only [ 'window', 'no-window' ]");
      //   }
      //   return true;
      // },
    },
  },
  data() {
    return {
      dropdownOptions: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  beforeMount() {
    if (this.propertyType === 'Residential') {
      // if (this.roomNumber > 0) {
      //   throw Error('Residential common area accepts only 0 as a roomNumber');
      // }

      this.dropdownOptions = {
        'window': 'Common area window sill',
        'no-window': 'Common area is bathroom with NO window sill',
      };
    } else {
      this.dropdownOptions = {
        'window': this.$sprintf('%s Common area window sill', numberText[this.roomNumber]),
        'no-window': this.$sprintf('%s Common area has not window sill', numberText[this.roomNumber]),
      };
    }
  },
};
</script>

<style>

</style>